export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="mt-32 border-t border-border/70 bg-background"
        >
            <div className="mx-auto grid max-w-[1400px] grid-cols-1 md:grid-cols-3 gap-8 px-6 py-12 lg:px-10">
                <div>
                    <div className="overline">// Archive</div>
                    <p className="mt-3 font-serif text-2xl text-foreground/90">
                        The Curated Mainframe
                    </p>
                    <p className="mt-2 font-sans text-sm text-muted-foreground leading-relaxed max-w-xs">
                        A living register of the machines that made computing personal.
                    </p>
                </div>
                <div>
                    <div className="overline">// System</div>
                    <ul className="mt-3 space-y-2 font-mono text-xs text-muted-foreground">
                        <li>STATUS ······· <span className="text-phosphor-green">ONLINE</span></li>
                        <li>UPTIME ······· 40Y 2M 15D</li>
                        <li>BUILD ········ v1.0.0</li>
                    </ul>
                </div>
                <div>
                    <div className="overline">// Signal</div>
                    <p className="mt-3 font-mono text-xs text-muted-foreground leading-relaxed">
                        &gt; Built with reverence for the pioneers.
                        <br />
                        &gt; 1975 — 1995.
                        <br />
                        &gt; End of transmission.
                    </p>
                </div>
            </div>
        </footer>
    );
}
